import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

/** Icon column (`h-5`, 20px) plus the row gap (10px): content below lines up with the title. */
export const ACTION_HEADER_INDENT_CLASS = 'pl-[30px]'
/** Center of the icon column, for connectors drawn down from the icon. */
export const ACTION_HEADER_ICON_CENTER_CLASS = 'left-[10px]'

interface ActionHeaderProps {
  icon: ReactNode
  title: ReactNode
  /** Secondary line under the title, indented with it (source attribution). */
  subtitle?: ReactNode
  /** Full-width block under the whole icon + title row (a meeting source card). */
  annotation?: ReactNode
  /** Unpadded by default; the host decides the inset. */
  className?: string
}

/**
 * Icon + title block shared by the Action View and every action row in the
 * Chat Output View.
 */
export function ActionHeader({ icon, title, subtitle, annotation, className }: ActionHeaderProps) {
  return (
    <div className={twMerge('flex shrink-0 flex-col gap-1', className)}>
      <div className="flex items-start gap-2.5">
        {icon}
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <span className="text-foreground type-ui-sm min-w-0 break-words font-medium">{title}</span>
          {subtitle ? <div className="flex min-w-0 items-center">{subtitle}</div> : null}
        </div>
      </div>
      {annotation}
    </div>
  )
}
